




































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import _ from "@/boot/lodash";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import MultilevelCategoriesFetcher from "@/components/app/admin/catalogue/products/multilevelCategories/multilevelCategoriesFetchMixin";

// Enums/Data
import { ProductTypes } from "@/data/enums/products";
import { DataModules, DEFAULT_LIST_SCOPE } from "@/store/modules/data";
import { ListDisplayMode } from "@/data/constants";

// Types
import { IProduct } from "@/models/products";

@Component({
  components: {
    "catalogue-products-provider": () =>
      import(
        "@/components/app/admin/catalogue/products/listing/catalogueProductsProvider.vue"
      ),
    "products-listing": () =>
      import(
        "@/components/app/admin/catalogue/products/listing/productsListing.vue"
      )
  },
  computed: {
    ...mapGetters({
      scopeGetter: "sortableCategories/getMainScope"
    })
  }
})
export default class CatalogueProductSearch extends Mixins(
  RequestPromises,
  MultilevelCategoriesFetcher
) {
  // Getters
  public scopeGetter!: string;

  @Prop({ default: /** [P]roducts [L]ist [1] */ `PL1` })
  public id!: string;

  @Prop({ default: true })
  public isMultiselect!: boolean;

  @Prop({ default: DEFAULT_LIST_SCOPE })
  public dataScope!: string;

  @Prop({ default: false })
  public ignoreHistory!: boolean;

  @Prop({ default: null })
  public selectedProducts!: {
    id: IProduct["id"];
    category_id: IProduct["category_id"];
  }[];

  @Prop({ default: true })
  public disableBundles!: boolean;

  @Prop({ default: null })
  public disabledProducts!: IProduct["id"][];

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: Record<string, any>;

  @Prop({ required: true })
  public showTreeView!: boolean;

  @Prop({
    default: () => [
      ListDisplayMode.TABLE,
      ListDisplayMode.TREE,
      ListDisplayMode.GRID
    ]
  })
  public availableModes!: ListDisplayMode[];

  // Variables
  public isLoading = false;
  public isReloading = false;
  public requestError = false;

  // Life cycle methods

  public async created() {
    if (!this.contentIsAvailable) return;

    this.isLoading = true;
    this.loadData();
  }

  // Methods

  public async loadData() {
    try {
      await this.getRootCategories(this.isReloading);
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isReloading = false;
      this.isLoading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public async openAddProductModal() {
    return this.$store.dispatch(
      `data/${DataModules.CATALOGUE}/openAddProductModal`,
      _.pick(this, ["productTypes"])
    );
  }

  // Computed

  public get productType() {
    return this.$t(
      this.isOption
        ? "_.product_option"
        : this.isAttribute
        ? "_.product_attribute"
        : "_.product"
    )
      .toString()
      .toLowerCase();
  }

  public get productTypeDesc() {
    return this.$t(
      this.isOption
        ? "_sentence.catalogue_options_onboarding_desc"
        : this.isAttribute
        ? "_sentence.catalogue_attributes_onboarding_desc"
        : "_sentence.catalogue_products_onboarding_desc"
    ).toString();
  }

  public get i18n() {
    return {
      cta: this.$t("_.add_your_first_object", { object: this.productType }),
      title: this.$t("_.add_your_first_object", {
        object: this.productType
      }),
      description: this.productTypeDesc
    };
  }

  public get image() {
    return this.isOption || this.isAttribute
      ? "/assets/images/interface/onboarding/create-product-option-attribute.svg"
      : "/assets/images/interface/onboarding/create-product.svg";
  }

  public get isOption() {
    return this.productTypes.includes(ProductTypes.PRODUCT_OPTION);
  }

  public get isAttribute() {
    return this.productTypes.includes(ProductTypes.PRODUCT_ATTRIBUTE);
  }

  public get isSelectable() {
    return !_.isNull(this.selectedProducts);
  }

  // Guarding and destroy

  public get guardFunctionalities() {
    if (this.isOption)
      return ["list_product_options_categories", "list_product_options"];

    if (this.isAttribute)
      return ["list_product_attributes_categories", "list_product_attributes"];

    return ["list_product_categories", "list_products"];
  }

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
